import { render } from "./SingUpOptions.vue?vue&type=template&id=36142212"
import script from "./SingUpOptions.vue?vue&type=script&lang=js"
export * from "./SingUpOptions.vue?vue&type=script&lang=js"

import "./SingUpOptions.vue?vue&type=style&index=0&id=36142212&lang=scss"
script.render = render

export default script